import { useReducer } from 'react';

const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_NEXT_SLIDE':
      return {
        ...state,
        start: state.start + 1,
        end: state.end + 1,
        filterId: action.value,
      };
    case 'SET_PREV_SLIDE':
      return {
        ...state,
        start: state.start - 1,
        end: state.end - 1,
        filterId: action.value,
      };
    case 'SET_ACTIVE_SLIDE':
      return {
        ...state,
        active: action.index,
        filterId: action.filterId,
        open: !state.open,
      };
    case 'TOGGLE_FILTERS':
      return {
        ...state,
        open: !state.open,
      };

    default:
      return state;
  }
};

const useFilterCategoriesHook = () => {
  const initialState = {
    start: 0,
    end: 5,
    active: 0,
    open: false,
    filterId: 0,
  };
  const [state, dispatch] = useReducer(reducer, initialState);
  return [state, dispatch];
};
export default useFilterCategoriesHook;
